import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, ElementRef, ViewChild, SimpleChanges, AfterViewChecked } from '@angular/core';

@Component({
  selector: 'groupaction-result',
  templateUrl: './groupaction.html',
  styleUrls: ['./groupactoin.scss'],
  imports: [CommonModule]
})
export class RestoreResultComponent implements OnChanges, AfterViewChecked {
  @Input() result: any[] = [];
  @Input() Show: boolean = false;
  @Input() typeaction: string = '';
  @ViewChild('resultCard') resultCard!: ElementRef<HTMLElement>;

  private shouldScroll = false;

  get successItems() {
    return this.result?.filter(i => i.status === 'success') || [];
  }

  get failedItems() {
    return this.result?.filter(i => i.status === 'failed') || [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Show'] && changes['Show'].currentValue === true) {
      this.shouldScroll = true; // just set the flag, don't scroll yet
    }
  }

  ngAfterViewChecked(): void {
    // DOM is ready here, ViewChild is resolved
    if (this.shouldScroll && this.resultCard?.nativeElement) {
      this.shouldScroll = false; // reset flag first to avoid loop
      setTimeout(() => {
        this.resultCard.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }
}